<template>
    <article>
        <p>
            No analysis is possible without having granular data describing a system.
            Coroot relies on metrics gathered by various open-source exporters:
        </p>

        <ul>
            <li>
                <router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'node-agent'}}">node-agent</router-link>
                gathers container metrics, such as resource consumption, logs and network communications</li>
            <li>
                <router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'pg-agent'}}">pg-agent</router-link>
                collects metrics from Postgres servers
            </li>
            <li>
                <router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'aws-agent'}}">aws-agent</router-link>
                discovers AWS services in use, such as RDS instances, to collect their telemetry
            </li>
        </ul>
    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
.block {
    border: 1px solid rgba(0, 0, 0, 0.17);
    border-radius: 4px;
    padding: 16px;
    margin: 16px 0;
}

.block-title {
    font-size: 24px;
    font-weight: 600;
}

</style>
